exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".employee-update-form_alert {\n  margin-bottom: 16px;\n}\n", ""]);

// exports
